
import clsBaseGlobal from './base'

const arrFillable = [
    "logo_data",
];


class clsGlobalPortal extends clsBaseGlobal {

    logo_data     = null;

    get fillable() { return arrFillable; }

}

export default clsGlobalPortal;